import './nav-stuff'

jQuery( document ).ready( function ( $ ) {

  $(window).scroll(function () {
    if ($(this).scrollTop()  <= 0 ){
      $('.navbar').removeClass('scrolling');
    } else {
      $('.navbar').addClass('scrolling');
    }
  });

  //Menus
  //++=====================================================================

  
  $( '.menu-btn' ).click( function ( e ) { // hide/show menu for mobile
    e.preventDefault();
    if ( $( this ).hasClass( 'active' ) ) {
      $( '.nav-overlay' ).fadeOut( 250 );
      $( this ).removeClass( 'active' );
      $( '.main-nav' ).removeClass( 'active' );
      $( 'body' ).removeClass( 'menu-active' );
    } else {
      $( '.nav-overlay' ).fadeIn( 250 );
      $( this ).addClass( 'active' );
      $( '.main-nav' ).addClass( 'active' );
      $( 'body' ).addClass( 'menu-active' );
    }
  } );

  $( '.nav-overlay' ).click( function ( e ) { // hides mobile menu on overlay click
    e.preventDefault();
    $( '.nav-overlay' ).fadeOut( 250 );
    $( '.menu-btn' ).removeClass( 'active' );
    $( '.main-nav' ).removeClass( 'active' );
    $( 'body' ).removeClass( 'menu-active' );
  } );

  $('.accordion-top').click(function(){
    $(this).parent('li').toggleClass('active');
  });

} );


